import { useRouter } from 'next/router';
import { Fragment, memo, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { LSTORAGE_KEY } from 'src/constants';
import { LocalStore, UrlUtils } from 'src/utils';
import { regionSelector } from 'src/selectors/app';
import { Element, Icon, RouterLink } from 'src/components';

interface IRegion {
    id: number;
    name: string;
    shortName: string;
}
const regions = [
    {
        id: 0,
        name: 'Chọn địa phương',
        shortName: '#',
    },
    {
        id: 0,
        name: 'Quanh bạn',
        shortName: 'QUANH_BAN',
    },
    {
        id: 1,
        name: 'An Giang',
        shortName: 'AN_GIANG',
    },
    {
        id: 6,
        name: 'Bắc Ninh',
        shortName: 'BAC_NINH',
    },
    {
        id: 12,
        name: 'Cà Mau',
        shortName: 'CA_MAU',
    },
    {
        id: 13,
        name: 'Cần Thơ',
        shortName: 'CAN_THO',
    },
    {
        id: 14,
        name: 'Cao Bằng',
        shortName: 'CAO_BANG',
    },
    {
        id: 15,
        name: 'Đà Nẵng',
        shortName: 'DA_NANG',
    },
    {
        id: 16,
        name: 'Đăk Lăk',
        shortName: 'DAK_LAK',
    },
    {
        id: 17,
        name: 'Đồng Nai',
        shortName: 'DONG_NAI',
    },
    {
        id: 18,
        name: 'Đồng Tháp',
        shortName: 'DONG_THAP',
    },
    {
        id: 19,
        name: 'Gia Lai',
        shortName: 'GIA_LAI',
    },
    {
        id: 22,
        name: 'Hà Nội',
        shortName: 'HA_NOI',
    },
    {
        id: 23,
        name: 'Hà Tĩnh',
        shortName: 'HA_TINH',
    },
    {
        id: 25,
        name: 'Hải Phòng',
        shortName: 'HAI_PHONG',
    },
    {
        id: 27,
        name: 'Hưng Yên',
        shortName: 'HUNG_YEN',
    },
    {
        id: 30,
        name: 'Khánh Hòa',
        shortName: 'KHANH_HOA',
    },
    {
        id: 31,
        name: 'Lai Châu',
        shortName: 'LAI_CHAU',
    },
    {
        id: 32,
        name: 'Lạng Sơn',
        shortName: 'LANG_SON',
    },
    {
        id: 33,
        name: 'Lào Cai',
        shortName: 'LAO_CAI',
    },
    {
        id: 34,
        name: 'Lâm Đồng',
        shortName: 'LAM_DONG',
    },
    {
        id: 37,
        name: 'Ninh Bình',
        shortName: 'NINH_BINH',
    },
    {
        id: 39,
        name: 'Nghệ An',
        shortName: 'NGHE_AN',
    },
    {
        id: 40,
        name: 'Phú Thọ',
        shortName: 'PHU_THO',
    },
    {
        id: 44,
        name: 'Quảng Ninh',
        shortName: 'QUANG_NINH',
    },
    {
        id: 45,
        name: 'Quảng Ngãi',
        shortName: 'QUANG_NGAI',
    },
    {
        id: 46,
        name: 'Quảng Trị',
        shortName: 'QUANG_TRI',
    },
    {
        id: 48,
        name: 'Sơn La',
        shortName: 'SON_LA',
    },
    {
        id: 49,
        name: 'Tây Ninh',
        shortName: 'TAY_NINH',
    },
    {
        id: 51,
        name: 'TP. HCM',
        shortName: 'HO_CHI_MINH',
    },
    {
        id: 52,
        name: 'TT Huế',
        shortName: 'THUA_THIEN_HUE',
    },
    {
        id: 53,
        name: 'Tuyên Quang',
        shortName: 'TUYEN_QUANG',
    },
    {
        id: 55,
        name: 'Thái Nguyên',
        shortName: 'THAI_NGUYEN',
    },
    {
        id: 56,
        name: 'Thanh Hóa',
        shortName: 'THANH_HOA',
    },
    {
        id: 58,
        name: 'Vĩnh Long',
        shortName: 'VINH_LONG',
    },
    {
        id: 63,
        name: 'Điện Biên',
        shortName: 'DIEN_BIEN',
    },
    {
        id: 64,
        name: 'Bắc Bộ',
        shortName: 'BAC_BO',
    },
    {
        id: 65,
        name: 'Tây Bắc Bộ',
        shortName: 'TAY_BAC_BO',
    },
    {
        id: 68,
        name: 'Đông Bắc Bộ',
        shortName: 'DONG_BAC_BO',
    },
    {
        id: 69,
        name: 'ĐB sông Hồng',
        shortName: 'DONG_BANG_SONG_HONG',
    },
    {
        id: 70,
        name: 'Trung Bộ',
        shortName: 'TRUNG_BO',
    },
    {
        id: 71,
        name: 'Bắc Trung Bộ',
        shortName: 'BAC_TRUNG_BO',
    },
    {
        id: 72,
        name: 'Nam Trung Bộ',
        shortName: 'NAM_TRUNG_BO',
    },
    {
        id: 73,
        name: 'Tây Nguyên',
        shortName: 'TAY_NGUYEN',
    },
    {
        id: 74,
        name: 'Nam Bộ',
        shortName: 'NAM_BO',
    },
    {
        id: 76,
        name: 'Đông Nam Bộ',
        shortName: 'DONG_NAM_BO',
    },
    {
        id: 77,
        name: 'Tây Nam Bộ',
        shortName: 'TAY_NAM_BO',
    },
];

interface IProps {
    onClick: () => void;
}

export function LocationSelect({ onClick }: IProps) {
    const router = useRouter();
    const region = useSelector(regionSelector);

    const defaultRegion =
        LocalStore.get<string>(LSTORAGE_KEY.SELECT_REGION) || '';
    const [regionName, selectRegion] = useState<string>('');
    const selectedRegions = regions.filter((item) => {
        return item.shortName === regionName;
    });
    const nameRegion = selectedRegions[0]?.name;
    const url = UrlUtils.getUrlLocation(regionName);

    useEffect(() => {
        if (defaultRegion) {
            selectRegion(defaultRegion);
        } else {
            selectRegion(region.shortName || regions[1].shortName);
        }
    }, [region, defaultRegion]);

    const onChange = useCallback(
        (e: any) => {
            const value = e.target.value;
            const url = UrlUtils.getUrlLocation(value);
            if (e.target.value !== '#') {
                onClick();
                selectRegion(value);
                LocalStore.set(LSTORAGE_KEY.SELECT_REGION, value);
                router.push(url);
            }
        },
        [onClick],
    );

    const renderRegion = (region: IRegion) => {
        return (
            <Element
                renderAs="option"
                value={region.shortName}
                key={region.id}
                label={region.name}
            >
                {region.name}
            </Element>
        );
    };

    const renderRegions = useCallback(() => {
        return regions.map((region, index: number) => {
            return (
                <Fragment key={`region.${index}`}>
                    {renderRegion(region)}
                </Fragment>
            );
        });
    }, []);

    return (
        <Element
            className={cn(
                'setting-menu',
                'flex items-center',
                'h-[56px]',
                'text-[16px] font-semibold',
                'pr-[10px] pl-[16px]',
                'mb-[8px]',
                'bg-[rgba(0,0,0,0.05)]',
            )}
        >
            <RouterLink
                className="flex items-center"
                to={url}
                onClick={onClick}
            >
                <Icon
                    className={cn(
                        'flex items-center justify-center',
                        'p-[6px] mr-[12px]',
                        'text-[28px]',
                        'bg-[rgba(0,0,0,0.05)]',
                        'rounded-full',
                    )}
                    icon="new-utility-location"
                />
                <Element renderAs="span">Tin {nameRegion}</Element>
            </RouterLink>
            <Element
                name="select"
                renderAs="select"
                defaultValue="Chọn địa phương"
                className={cn(
                    'breadcrumb-select',
                    'text-[14px] text-black text-left',
                    'ml-auto pr-[32px] pl-[16px]',
                    'w-[165px] h-[40px]',
                    'bg-white',
                    'rounded-full',
                    'appearance-none',
                    'relative',
                    'truncate',
                )}
                onChange={onChange}
            >
                {renderRegions()}
            </Element>
            <Icon
                className="text-[12px] absolute right-[22px] rotate-90 pointer-events-none"
                icon="new-arr-right-regular"
            />
        </Element>
    );
}

export default memo(LocationSelect);
